import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class HolidaySettingModel extends BaseModel {

    constructor() {
        super({ 
                name: "holiday_setting",
                tableName: 'holiday_setting', 
                label: "Cài đặt ngày nghỉ", 
                display_key: 'name', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center", 
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            date_off: {
                name: 'date_off', 
                type: "Date",
                label: 'Ngày nghỉ',
                width: 10,
                class: "center", 
                // filter: { type: 'input', match: 'contains'},
                // display: false
                filter: { type: "DateRange" , match: "contains"}
            },
            name: {
                name: 'name', 
                type: "String",
                label: 'Tiêu đề ngày nghỉ',
                class: 'center',
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
        },)
    }

}